<template>
  <div :class="`container ${plat}`">
    <div class="page page-04">
      <div class="pg-tit" :style="psy">
        <img src="../../assets/img_dynamic.png" alt="">
      </div>
      <div class="pg04-cnt">
        <div class="pg04-one">
          <div class="pg04-title">招聘流程</div>
          <div class="pg04-one-cnt">
            <div class="process-item" v-for="(item, index) in ProcessLst" :key="index">
              <div class="process-item-left">
                <img :src="item.ImgUrl" alt="">
                <p class="item-name">{{item.Name}}</p>
                <!-- <p class="item-date">{{item.PDate}}</p> -->
              </div>
              <div class="process-item-right" v-if="index !== ProcessLst.length - 1">
                <img src="../../assets/img_arrow.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="pg04-two">
          <div class="pg04-title">招聘公告</div>
          <div class="pg04-two-tab">
            <span class="tab-01 active">线下招聘会</span>
            <span>线上宣讲会</span>
          </div>
          <div class="pg04-two-cnt">
            <div class="list">
              <ul class="list-header">
                <li>场次</li>
                <li>内容</li>
                <li>日期</li>
                <li>时间</li>
                <li>地点</li>
              </ul>
              <div class="list-content-box" style="overflow:hidden;">
                <div class="list-content">
                  <ul v-for="(item, index) in NoticeList" :key="index">
                    <li>{{item.Sessions}}</li>
                    <li>{{item.Content}}</li>
                    <li>{{item.Date}}</li>
                    <li>{{item.Time}}</li>
                    <li>{{item.Address}}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
       
      </div>
    </div>
  </div>
</template>

<script>
import img1 from '../../assets/img_apply.png'
import img2 from '../../assets/img_evaluation.png'
import img3 from '../../assets/img_interview.png'
import img4 from '../../assets/img_offer.png'
import img5 from '../../assets/img_Induction.png'

export default {
  data() {
    return {
      readonly: false,
      plat: `plat-${this.$store.state.plat}`,
      psy: { display: this.$store.state.plat === 'Web' ? '' : 'none' },
      msy: { display: this.$store.state.plat === 'Mobile' ? '' : 'none' },
      ProcessLst: [
        {
          ImgUrl: img1,
          Name: '网申',
          PDate: '11月13日-11月31日 17:30'
        },
        {
          ImgUrl: img2,
          Name: '测试/笔试',
          PDate: '12月上旬开始'
        },
        {
          ImgUrl: img3,
          Name: '面试',
          PDate: '12月中旬开始'
        },
        {
          ImgUrl: img4,
          Name: 'Offer发放',
          PDate: '1月上旬开始'
        },
        {
          ImgUrl: img5,
          Name: '体检入职',
          PDate: '入职报告前'
        },
      ],
      NoticeList: [
        {
          Sessions: '福建工程学院专场',
          Content: '研发类岗位专场招聘会',
          Date: '2021-12-01',
          Time: '09:00',
          Address: '福州市大学新区学府南路33号旗山校区图书馆广场'
        },
        {
          Sessions: '福建师范大学专场',
          Content: '研发类岗位专场招聘会',
          Date: '2021-12-01',
          Time: '10:00',
          Address: '福州市大学城科技路1号旗山校区图书馆广场'
        },
        {
          Sessions: '福州大学专场',
          Content: '研发类岗位专场招聘会',
          Date: '2021-12-13',
          Time: '09:00',
          Address: '福州市大学新区学府南路33号旗山校区图书馆广场'
        },
        {
          Sessions: '天津大学专场',
          Content: '研发类岗位专场招聘会',
          Date: '2021-12-13',
          Time: '15:00',
          Address: '天津市津南区海河教育园区北洋园校区图书馆广场'
        },
        {
          Sessions: '南开大学专场',
          Content: '研发类岗位专场招聘会',
          Date: '2021-12-26',
          Time: '10:00',
          Address: '天津市南开区八里台八里台校区图书馆广场'
        },
      ]
    }
  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
  @import "../../components/common/common.less";
  .container{
    height: auto;
    .plat-Mobile {
      height: unset;
      min-height: 100%;
      .page-04 {
        height: unset;
        min-height: 100%;
        .pg04-cnt {
          padding: 0;
          height: unset;
          min-height: 100%;
          .pg04-right {
            float: unset;
            width: 100%;
            height: unset;
            border: none;
            margin-right: 0;
            border-radius: 0;
          }
          .pg04-left {
            float: unset;
            width: 100%;
            height: unset;
            min-height: 100%;
            padding: 10px 14px 20px 14px;
            ul {
              height: unset;
              min-height: calc(100vh - 130px);
            }
            .li-card {
              .arrow {
                display: none;
              }
            }
          }
        }
      }
    }
    .page-04 {
      height: 100%;
      .pg04-cnt {
        width: 100%;
        height: calc(100% - 162px);
        padding: 0 18%;
        box-sizing: border-box;
        .pg04-title{
          font-size: 32px;
          font-weight: bold;
          margin-bottom: 24px;
        }
        .pg04-one {
          width: 100%;
          .pg04-one-cnt {
            display: flex;
            justify-content: space-between;
            margin: 50px 7% 70px;
            .process-item {
              width: 20%;
              display: flex;
              justify-content: space-between;
              .process-item-left{
                display: flex;
                align-items: center;
                flex-direction: column;
                .item-name{
                  margin: 20px 0 10px;
                  color: #1F2329;
                  font-size: 22px;
                }
                .item-date{
                  width: 146px;
                  font-size: 16px;
                  color: #666;
                  text-align: center;
                  overflow: hidden;      
                  text-overflow: ellipsis;      
                  display: -webkit-box; 
                  -webkit-line-clamp: 2; 
                  -webkit-box-orient: vertical;
                }
                img {
                  width: 88px;
                }
              }
              .process-item-right {
                height: 88px;
                display: flex;
                align-items: center;
                img {
                  width: 18px;
                }
              }
            }
          }
        }
        .pg04-two {
          padding-bottom: 60px;
          .pg04-two-tab {
            margin-bottom: 19px;
            span{
              font-size: 22px;
              color: #666;
              &.active {
                color: #FF5F00;
              }
            }
            .tab-01:after {
              content: '|';
              color: #707070;
              margin: 0 10px 0 12px;
            }
          }
          .pg04-two-cnt {
            .list {
              ul {
                width: 100%;
                display: flex;
                height: 45px;
                li {
                  font-size: 16px;
                  display: flex;
                  align-items: center;
                  padding-left: 10px;
                  &:first-child {
                    width: 18%;
                  }
                  &:nth-child(2) {
                    width: 22%;
                  }
                  &:nth-child(3) {
                    width: 12%;
                  }
                  &:nth-child(4) {
                    width: 8%;
                  }
                  &:last-child {
                    width: 40%;
                  }
                }
              }
              .list-header {
                background: #F5F5F5;
                li {
                  color: #666;
                }
              }
              .list-content {
                max-height: 225px;
                overflow-y: auto;
                .cmScroll(hidden, auto, transparent, 8px);
                ul {
                  li {
                    color: #1F2329;
                  }
                }
              }
            }
          }
        }
        &::after {
          content: ' ';
          display: block;
          clear: both;
        }
      }
      &::after {
        content: ' ';
        display: block;
        clear: both;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/cap-page-04/cap-page-04.vue